export interface LinearMeasurements {
  ridges: number;
  hips: number;
  valleys: number;
  eaves: number;
  rakes: number;
}

export interface CalculatedQuantities {
  totalSquares: number;
  shingleBundles: number;
  underlaymentSquares: number;
  iceWaterShieldLF: number;
  starterStripsBundles: number;
  ridgeCapBundles: number;
  dripEdgeFeet: number;
  nailsLbs: number;
}

/**
 * Calculates raw material quantities based on area (squares) and linear feet.
 * Uses industry standard conversion factors.
 */
export function calculateRoofingMaterials(
  squares: number,
  edges: LinearMeasurements
): CalculatedQuantities {
  // 1. Calculate Squares (Total Squares + 10% Waste)
  const totalSquares = Math.ceil(squares * 1.1);

  // 2. Shingles: 3 bundles per square
  const shingleBundles = Math.ceil(totalSquares * 3);

  // 3. Underlayment: Total squares + 5% for overlap/cuts
  const underlaymentSquares = Math.ceil(squares * 1.05);

  // 4. Ice & Water Shield: Required for eaves and valleys. Use 3ft wide strip.
  const iceWaterShieldLF = (edges.eaves * 2) + (edges.valleys * 2);

  // 5. Starter Strip: Required for eaves (33 LF per bundle)
  const starterStripsBundles = Math.ceil(edges.eaves / 33);

  // 6. Ridge Cap: Required for ridges (33 LF per bundle)
  const ridgeCapBundles = Math.ceil(edges.ridges / 33);

  // 7. Drip Edge: Required for eaves and rakes (total perimeter of those edges)
  const dripEdgeFeet = edges.eaves + edges.rakes;

  // 8. Nails: Approximately 10 lbs per square
  const nailsLbs = Math.ceil(squares * 10);

  return {
    totalSquares,
    shingleBundles,
    underlaymentSquares,
    iceWaterShieldLF,
    starterStripsBundles,
    ridgeCapBundles,
    dripEdgeFeet,
    nailsLbs,
  };
}

export function calculateLineTotals(items: any[]): {
  materialTotal: number;
  laborTotal: number;
  grandTotal: number;
} {
  let materialTotal = 0;
  let laborTotal = 0;

  items.forEach((item) => {
    const qty = item.quantity || 0;
    const matCost = item.material_cost || 0;
    const labCost = item.labor_cost || 0;
    
    materialTotal += qty * matCost;
    laborTotal += qty * labCost;
  });

  return {
    materialTotal,
    laborTotal,
    grandTotal: materialTotal + laborTotal,
  };
}
